import React, { useState } from "react";
import { useSelector } from "react-redux";
import MyDealerPage from "./my-dealer.page";
import {AccessRights} from "lib/constants/accessRights";
import LoadingComponent from "components/loading";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import {canAccess} from "../../../../profile/redux/selector/profile.selector";

function MyDealerContainer() {
  const canViewDealer = useSelector(state =>
    canAccess(state, AccessRights.TrackcoPortal.DEALER_READ));
  const canCreateDealer = useSelector(state =>
    canAccess(state, AccessRights.TrackcoPortal.DEALER_CREATE));

  const [isInviteDialogOpen, setIsInviteDialogOpen] = useState(false);
  const lang = useSelector(state => state.constant.languages);
  const history = useHistory();

  const handleVisibleInviteDialog = (value) => {
    setIsInviteDialogOpen(value);
  }

  useEffect(() => {
    if (!canViewDealer) {
      history.push('/admin/dashboard')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!canViewDealer) return <LoadingComponent />;

  return (
    <>
      <MyDealerPage
        canCreateDealer={canCreateDealer}
        canViewDealer={canViewDealer}
        isInviteDialogOpen={isInviteDialogOpen}
        handleVisibleInviteDialog={handleVisibleInviteDialog}
        lang={lang}
      />
    </>
  )
}

export default MyDealerContainer;
